<template lang="pug">
    el-dialog(title="培训人员管理",width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="handData",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="培训ID" prop="matchId")
                    div.width_label {{handData.trainCode}}
                el-form-item(label="培训名称" prop="matchName")
                    div.width_label {{handData.name}}
                el-form-item(label="培训类型")
                    div.width_label {{pxType[handData.type]}}
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{handData.orgName}}
                el-form-item(label="培训场地")
                    div.width_label {{handData.placesName}}
                br
                el-form-item(label="级别" prop="level")
                        div.width_label {{handData.level}}
                el-form-item(label="班级人数" prop="classCount")
                        div.width_label {{nowPerNum}}/{{handData.classCount}}
                el-form-item(label="培训时间")
                        div.width_label {{handData.trainStrDate}}
                el-form-item(label="状态")
                    div.width_label {{stateName||pxState[handData.state]}}
            el-row(style="padding-top:30px")
                el-col(:span="24")
                    el-button(type="primary" @click="addEnrollView" :disabled="isDesabled||handData.state==7") 添加人员
                    el-button(type="danger" @click="delEnroll(null)" :disabled="isDesabled||handData.state==7") 删除人员
                    el-button(type="primary" @click="clickRefund" :disabled="handData.state==7") 退 款
                    //- el-button(type="primary" @click="exportExcel") 名单导出
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div(slot="header")
                        font.font_label 参训人员
                      div
                        el-table(:data="enrollDataOne" border @selection-change="enrollOneChange")
                                el-table-column(type="selection" align='center' width='40')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column( prop="trainNum" label="培训次数" align='center')
                                    template(slot-scope="scope")
                                        font {{ scope.row.trainNum || 0 }}
                                el-table-column(prop="mobile" label="会员账号" align='center' width="130")
                                el-table-column(prop="accountType" label="账户属性" align='center' width="80")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.accountType == 0") 一般账户
                                        font(v-if="scope.row.accountType == 1") 青少年账户                                  
                                el-table-column(prop="gender" label="性别" align='center' width="60")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.gender === 0") 男
                                        font(v-if="scope.row.gender === 1") 女
                                el-table-column(prop="age" label="年龄" align='center' width="60")
                                el-table-column(prop="level" label="级别" align='center' width="60")
                                el-table-column(prop="type" label="会员类型" align='center' width="130")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.type == 1") 注册会员
                                        font(v-if="scope.row.type == 2") 初始会员
                                        font(v-if="scope.row.type == 3") 荣誉会员
                                el-table-column(prop="payStatus" label="状态" align='center' width="80")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payStatus === 0") 未支付
                                        font(v-if="scope.row.payStatus === 1") 支付中
                                        font(v-if="scope.row.payStatus === 2") 支付成功
                                        font(v-if="scope.row.payStatus === 3") 支付失败
                                        font(v-if="scope.row.payStatus === 4") 超时
                                        font(v-if="scope.row.payStatus === 5") 申请退款
                                        font(v-if="scope.row.payStatus === 6") 退款中
                                        font(v-if="scope.row.payStatus === 7") 退款成功
                                        font(v-if="scope.row.payStatus === 8") 退款失败
                                        font(v-if="scope.row.payStatus === 9") 支付已关闭
                                        font(v-if="scope.row.payStatus === 10") 退款已取消
                                el-table-column(prop="payType" label="支付方式" align='center')
                                    template(slot-scope="scope")
                                        font() {{payType[scope.row.payType]}}
                                el-table-column(prop="payAmount" label="支付金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount") ￥{{parseFloat(scope.row.payAmount).toFixed(2)}}元
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale !== null") {{scope.row.refundScale}}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundFee !== null") ￥{{parseFloat(scope.row.refundFee).toFixed(2)}}元
                                el-table-column(prop="refundDesc" label="退款说明" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="!!scope.row.refundDesc") {{scope.row.refundDesc}}
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(:collapse="isCollapse" )
                                            el-submenu(index="1")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group()
                                                    el-menu-item(index="1-1" @click="updateBench(scope.row,2)" v-if="isbench==1" :disabled="isDesabled||handData.state==7") 设为替补
                                                    el-menu-item(index="1-5" @click="clickRefund(1,scope.row)" :disabled="handData.state==7") 退款
                                                    el-menu-item(index="1-2" @click="delEnroll(scope.row)" :disabled="isDesabled||handData.state==7") 删除人员
                                                    el-menu-item(index="1-4" @click="LookStudentEvaluation(scope.row)") 查看学员评价
                                                    el-menu-item(index="1-6" @click="viewParent(scope.row)" :disabled="scope.row.accountType!=1") 查看家长
            el-row(style="padding-top:30px" v-if="isbench==1")
                el-col(:span="24")
                    el-card(shadow="never")
                        div(slot="header")
                            font.font_label 替补人员
                        div
                            el-table(:data="enrollDataTwo" border @selection-change="enrollTwoChange")
                                el-table-column(type="selection" align='center' width='40')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column( prop="trainNum" label="培训次数" align='center')
                                    template(slot-scope="scope")
                                        font {{ scope.row.trainNum || 0 }}
                                el-table-column(prop="mobile" label="会员账号" align='center' width='130')
                                el-table-column(prop="gender" label="性别" align='center' width='60')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.gender === 0") 男
                                        font(v-if="scope.row.gender === 1") 女
                                el-table-column(prop="age" label="年龄" align='center' width='60')
                                el-table-column(prop="level" label="级别" align='center' width='60')
                                el-table-column(prop="type" label="会员类型" align='center' width='130')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.type == 1") 注册会员
                                        font(v-if="scope.row.type == 2") 初始会员
                                        font(v-if="scope.row.type == 3") 荣誉会员
                                el-table-column(prop="payStatus" label="状态" align='center' width='80')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payStatus === 0 || !scope.row.payStatus") 未缴费
                                        font(v-if="scope.row.payStatus === 1") 支付中
                                        font(v-if="scope.row.payStatus === 2") 已缴费
                                        font(v-if="scope.row.payStatus === 3") 支付失败
                                        font(v-if="scope.row.payStatus === 4") 超时
                                        font(v-if="scope.row.payStatus === 5") 申请退款
                                        font(v-if="scope.row.payStatus === 6") 退款中
                                        font(v-if="scope.row.payStatus === 7") 退款成功
                                        font(v-if="scope.row.payStatus === 8") 退款失败
                                        font(v-if="scope.row.payStatus === 9") 支付已关闭
                                        font(v-if="scope.row.payStatus === 10") 退款已取消
                                el-table-column(prop="payType" label="支付方式" align='center')
                                    template(slot-scope="scope")
                                        font() {{payType[scope.row.payType]}}
                                el-table-column(prop="payAmount" label="支付金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount") ￥{{parseFloat(scope.row.payAmount).toFixed(2)}}元
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale !== null") {{scope.row.refundScale}}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundFee !== null") ￥{{parseFloat(scope.row.refundFee).toFixed(2)}}元
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(:collapse="isCollapse" )
                                            el-submenu(index="2")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group()
                                                    el-menu-item(index="2-1" @click="updateBench(scope.row,1)" :disabled="isDesabled||handData.state==7") 设为参训
                                                    el-menu-item(index="2-2" @click="delEnroll(scope.row)" :disabled="isDesabled||handData.state==7") 删除人员
            el-dialog(title="添加人员"  :visible.sync="addVisible" width="80%" :append-to-body='true' :modal-append-to-body='false')
                el-row
                   el-col(:span="11")
                      el-card(shadow="never")
                        div(slot="header")
                            el-row
                                el-col(:span='22')
                                    el-input(v-model='memberName' clearable='', style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                                el-col(:span='2')
                                    el-button(@click="getLeftData" style='float:right;' icon='el-icon-search') 查询
                        div
                          el-table(:data="leftData" border  @selection-change="checkAll" max-height="300")
                              el-table-column(type="selection" align='center')
                              el-table-column(prop="name" label="姓名" align='center')
                              el-table-column(prop="gender" label="性别" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                              el-table-column(prop="level" label="级别" align='center'  )
                              el-table-column(prop="mobile" label="手机号码" align='center' )
                              el-table-column(prop="idCard" label="身份证号" align='center'  )
                              el-table-column(prop="accountType" label="账户属性" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.accountType === 0") 一般账户
                                    font(v-if="scope.row.accountType === 1") 青少年账户
                          el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
                   el-col(:span="2")
                      div.opSetting
                          div(@click="handelSelect" )
                              el-button(style='padding:10px'    icon="el-icon-d-arrow-right" :disabled="nowSelectData.length ? false:true" :size="buttonSize" type="primary") 选中
                          div.spacing(@click="handleRemoveSelect")
                              el-button(style='padding:10px' icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length ? false:true" :size="buttonSize" type="danger") 取消
                   el-col(:span="11")
                        el-card(shadow="never")
                            div(slot="header")
                                font.font_label 已选择的会员
                            div
                                el-table(:data="rightData" border @selection-change="checkRightAll" max-height="300")
                                    el-table-column(type="selection" align='center')
                                    el-table-column(prop="name" label="姓名" align='center')
                                    el-table-column(prop="gender" label="性别" align='center' )
                                        template(slot-scope="scope")
                                            font(v-if="scope.row.gender === 0") 男
                                            font(v-if="scope.row.gender === 1") 女
                                    el-table-column(prop="level" label="级别" align='center' )
                                    el-table-column(prop="mobile" label="手机号码" align='center' )
                                    el-table-column(prop="idCard" label="身份证号" align='center'  )
                                    el-table-column(prop="accountType" label="账户属性" align='center'  )
                                      template(slot-scope="scope")
                                        font(v-if="scope.row.accountType === 0") 一般账户
                                        font(v-if="scope.row.accountType === 1") 青少年账户
                span.dialog-footer(slot="footer")
                    el-button(@click="addEnroll" type="primary") 确 定
                    el-button(@click="addVisible=false") 取 消
            el-dialog(title="查看家长"  :visible.sync="viewParentVisible" width="50%" :append-to-body='true' :modal-append-to-body='false')
                el-row
                   el-col(:span="24")
                        div
                          el-table(:data="parentList" border  @selection-change="checkAll" max-height="300")
                              el-table-column(type="selection" align='center')
                              el-table-column(prop="name" label="姓名" align='center')
                              el-table-column(prop="mobile" label="会员账号" align='center' )
                              el-table-column(prop="accountType" label="账户属性" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.accountType === 0") 一般账户
                                    font(v-if="scope.row.accountType === 1") 青少年账户
                              el-table-column(prop="level" label="级别" align='center'  )
                              el-table-column(prop="type" label="会员类型" align='center' width="130")
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.type == 1") 注册会员
                                    font(v-if="scope.row.type == 2") 初始会员
                                    font(v-if="scope.row.type == 3") 荣誉会员
                //-人员不符合情况弹窗
                el-dialog(title="添加人员信息不符合：" :visible.sync='addpersonError' :append-to-body='true' :modal-append-to-body='false')
                    div(v-for="(e,i) in addpersonErrorInfo.split('。')" :key="i") {{e}}
                    span.dialog-footer(slot="footer")
                        el-button(@click="addpersonError=false") 取 消

            el-dialog(title="退款" :visible.sync='refundVisible' :append-to-body='true' :modal-append-to-body='false')
                el-form(:model="refundForm" ref="refundForm" style="padding:30px;")
                    el-row
                       el-col(:span="8")
                            div(style="float:right")
                              el-radio(v-model="radio" label="1" border) 按比例退款
                       el-col(:span="16")
                            el-form-item(prop="refundScale" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio==1 ? false : true" v-model="refundForm.refundScale" :min=0 :max=100 )
                    el-row
                        el-col(:span="8")
                            div(style="float:right")
                                el-radio(v-model="radio" label="2" border) 按固定金额退款
                        el-col(:span="16")
                            el-form-item(prop="refundFee" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio==2 ? false : true" v-model="refundForm.refundFee" :min=0 :max='refundFeeMax' :precision="2" )
                    el-row
                        el-col(:span="8" style="margin-right:26px")
                            div(style="text-align:right;margin-right:-14px") 退款说明：
                        el-col(:span="8")
                            el-input(v-model="refundForm.refundDesc" type="textarea" :rows=6 resize="none" maxlength="99" show-word-limit)
                span.dialog-footer(slot="footer")
                    el-button(@click="comfirmRefundRee" type="primary" :disabled='refundBtn') 确 定
                    el-button(@click="refundVisible=false") 取 消
            StudentEvaluations(v-if="releaseVisible", ref="releaseReserve" @Closestudent='Closestudent')
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回
</template>
<script>
import commonData from '../common.js'
import StudentEvaluations from './StudentEvaluation.vue'

export default {
  data () {
    return {
      releaseVisible: true,
      refundBtn: false,
      isDesabled: false,
      pxLevel: commonData.pxLevel,
      pxState: commonData.pxState2,
      pxType: commonData.pxType,
      payType: commonData.payType,
      stateName: '',
      addpersonErrorInfo: '',
      addpersonError: false,
      nowPerNum: 0,
      handData: {
        trainCode: ''
      }, //头部回显
      trainPersonList: {}, //请求添加人员数据
      trainId: '', //培训id
      isbench: '',
      isCollapse: true,
      table: {
        // columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      argueVisible: false,
      addOrViewArgue: true,
      argueTitle: '',
      argueForm: {
        argue: ''
      },
      refundList: [],
      regMember: '', //注册会员
      initMember: '', //初始化会员
      honour: '', //荣誉会员
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      memberName: '',
      buttonSize: 'large',
      options: [],
      value: '',
      leftData: [],
      rightData: [], // 右边列表
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      visible: false,
      addVisible: false,
      viewParentVisible:false,
      refundVisible: false,
      enrollData: [],
      enrollDataOne: [],
      enrollDataTwo: [],
      enrollDataChange: [],
      enrollDataOneChange: [],
      enrollDataTwoChange: [],
      parentList:[],
      ruleForm: {
        id: '',
        ctId: '',
        matchName: '',
        orgId: '',
        city: '',
        province: '',
        placeId: '',
        ctType: '',
        applySize: '',
        projectType: null,
        level: '',
        bench: '1',
        applyDate: [],
        matchSignStartTime: '',
        matchSignEndTime: '',
        matchStartTime: '',
        imgList: '',
        gameDescription: '',
        matchDescription: '',
        imgDetailList: '',
        repeatSign: '0',
        genderLimit: '2',
        ageLimit: '',
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: '',
        ctRefundList: [],
        byx1: '',
        verifyReason: '',
        orderForm: 1
      },
      enrollList: {
        memberId: '',
        bench: '0', //是否替补队员 0:否 1:是
        matchType: 1, //业务类型（1分级赛、2俱乐部）,
        mbMemberList: []
      },
      payRefund: null,
      refundForm: {
        refundScale: undefined,
        refundFee: undefined,
        refundDesc: ''
      },
      radio: undefined,
      loading: null,
      refundFeeMax: 0
    }
  },
  components: {
    StudentEvaluations
  },
  methods: {
    //   查看学员评价
    LookStudentEvaluation (val) {
      console.log(val)
      this.releaseVisible = true
      this.$nextTick(() => {
        this.$refs.releaseReserve.init(val)
      })
      //   const loading = this.$loading({
      //     lock: true,
      //     text: 'Loading',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      //   })
      //   setTimeout(() => {
      //     loading.close()
      //   }, 2000)
    },
    Closestudent () {
      this.releaseVisible = false
    },
    //刷新添加人员左边table
    getLeftData () {
      let arrId = []
      for (let i of this.enrollData) {
        arrId.push(i.mbId)
      }
      for (let i of this.rightData) {
        arrId.push(i.id)
        console.log(i.id)
      }
      for (let i of this.enrollDataOne) {
        arrId.push(i.memberId)
        console.log(i.memberId)
      }
      for (let i of this.enrollDataTwo) {
        arrId.push(i.memberId)
        console.log(i.memberId)
      }

      this.$http({
        url: this.$http.adornUrl(`/mbMember/getMemberList`),
        method: 'post',
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          name: this.memberName,
          status: 1, //只查询已实名认证的会员
          ids: arrId.join()
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.list.rows
          this.totalPage = data.list.total
        } else {
          this.leftData = []
          this.totalPage = 0
        }
      })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //添加人员入库
    addEnroll () {
      if (this.rightData.length === 0) {
        return this.$message.error('没有要添加的会员!')
      } else if (this.rightData.length > 0) {
        this.openFullScreen()
        this.trainPersonList = []
        let item = {}
        this.rightData.forEach((e) => {
          item = {}
          item.memberId = e.id
          this.trainPersonList.push(item)
        })
        //先校验
        this.$http({
          url: this.$http.adornUrl(`/pxTrain/checkTrainMember`),
          method: 'post',
          data: {
            id: this.handData.id,
            trainPersonList: this.trainPersonList,
            isPlacement: 1
          }
        }).then((data) => {
          console.log(data, '校验参训人员')
          if (data && data.code === 0) {
            if (data.state) {
              console.log('验证通过')
              this.$http({
                url: this.$http.adornUrl(`/pxTrain/addPersonSave`),
                method: 'post',
                data: {
                  id: this.handData.id,
                  trainPersonList: this.trainPersonList,
                  isPlacement: 1
                }
              }).then((data) => {
                console.log(data)
                if (data && data.code === 0) {
                  this.addVisible = false
                  this.$message.success('添加成功!')

                  this.getTrainPerson(1)
                  this.getTrainPerson(2)
                  this.loading.close()
                } else {
                  this.$message.success('添加失败!')
                  this.loading.close()
                }
              })
            } else {
              
              this.loading.close()
              this.addpersonError = true
              this.addpersonErrorInfo = data.info
              this.$message.error(data.info ? data.info : '操作失败！')
            }
          } else {
            this.$message.error(data.msg ? data.msg : '操作失败！')
            this.loading.close()
          }
        })
      }
    },
    //添加人员页面
    addEnrollView () {
      this.addVisible = true
      this.memberName = ''
      this.rightData = []
      this.enrollList = {}
      this.nowSelectRightData = []
      this.nowSelectRightData = [] // 右边选中列表数据
      this.enrollList.ctId = this.ruleForm.id
      this.getLeftData()
    },

    //退款弹窗事件
    clickRefund (btn, row) {
      console.log('退款按钮：', row)
      this.radio = undefined
      this.payRefund = {}
      //支付状态(-1全部，0未支付,1支付中,2支付成功,3支付失败,4超时,5申请退款,6退款中,7退款成功,8退款失败,9支付已关闭，10退款已取消)
      if (btn == 1) {
        //操作栏退款
        if (
          row.payStatus === 0 ||
          row.payStatus === 1 ||
          row.payStatus === 3 ||
          row.payStatus === 4
        ) {
          this.$message.error('提示：未缴费不能退款！')
          return
        }
        if (row.payStatus === 5) {
          this.$message.error('提示：已发起退款申请！')
          return
        }
        if (row.payStatus === 6 || row.payStatus === 8) {
          this.$message.error('提示：退款中！')
          return
        }
        if (row.payStatus === 7) {
          this.$message.error('提示：已完成退款！')
          return
        }
        this.payRefund.id = row.id
        if (row.payAmount === '0') {
          //单个退款0元支付时不弹窗，直接退款
          this.payRefund.refundScale = 0
          this.payRefund.refundFee = 0
          this.submitRefund()
        } else {
          this.refundVisible = true
          this.refundFeeMax = parseFloat(row.payAmount).toFixed(2)
        }
        this.refundFeeMax = parseFloat(this.refundFeeMax)
      } else {
        //批量退款
        // this.payRefund = null
        //替补人员不需要退费操作
        if (this.enrollDataOneChange.length === 0) {
          this.$message.error('提示：请勾选要退费的人员！')
          return
        }
        console.log('勾选的退款人员', this.enrollDataOneChange)
        let feeFlag = false
        let feeInfo = ''
        let idArr = []
        this.refundFeeMax = parseFloat(
          this.enrollDataOneChange[0].payAmount
        ).toFixed(2)
        this.enrollDataOneChange.forEach((row) => {
          if (
            row.payStatus === 0 ||
            row.payStatus === 1 ||
            row.payStatus === 3 ||
            row.payStatus === 4
          ) {
            feeInfo = '提示：未缴费不能退款！'
            feeFlag = true
            return
          }
          if (row.payStatus === 5) {
            feeInfo = '提示：已发起退款申请！'
            feeFlag = true
            return
          }
          if (row.payStatus === 6 || row.payStatus === 8) {
            feeInfo = '提示：退款中！'
            feeFlag = true
            return
          }
          if (row.payStatus === 7) {
            feeInfo = '提示：已完成退款！'
            feeFlag = true
            return
          }
          idArr.push(row.id)
          //退款金额赋最大值
          if (this.refundFeeMax > parseFloat(row.payAmount).toFixed(2)) {
            this.refundFeeMax = parseFloat(row.payAmount).toFixed(2)
          }
        })
        if (feeFlag) {
          this.$message.error(feeInfo)
          return
        }
        console.log('已选退费人员id：', idArr)
        console.log('已选退费人员id：', idArr.join())
        this.payRefund.id = idArr.join()
        this.refundFeeMax = parseFloat(this.refundFeeMax)
        if (this.refundFeeMax === 0) {
          //都是0元退款不弹窗直接退
          this.refundVisible = false
          this.refundForm.refundScale = 0
          this.refundForm.refundFee = 0
          this.submitRefund()
        } else {
          this.refundVisible = true
          this.refundForm.refundScale = undefined
          this.refundForm.refundFee = undefined
          this.refundForm.refundDesc = ''
        }
      }
    },

    //退款提交事件
    comfirmRefundRee () {
      console.log('退款信息：', this.refundForm)
      if (this.radio === undefined) {
        this.$message.error('请选择按比例或者固定金额退款!')
        return
      }
      if (this.radio == 1) {
        if (!this.refundForm.refundScale && this.refundFeeMax > 0) {
          this.$message.error('请填写退款比例!')
          return
        } else {
          this.payRefund.refundScale = this.refundForm.refundScale
          this.payRefund.refundFee = undefined
          this.refundForm.refundFee = undefined
        }
      }
      if (this.radio == 2) {
        if (!this.refundForm.refundFee && this.refundFeeMax > 0) {
          this.$message.error('请填写固定金额退款!')
        } else {
          this.payRefund.refundFee = this.refundForm.refundFee
          this.payRefund.refundScale = undefined
          this.refundForm.refundScale = undefined
        }
      }
      this.submitRefund()
    },
    submitRefund () {
      if (this.refundFeeMax === 0) {
        if (!this.payRefund.refundFee) {
          this.payRefund.refundFee = 0
        }
        if (!this.payRefund.refundScale) {
          this.payRefund.refundScale = 0
        }
      }
      console.log('退款确定：', this.payRefund)
      this.refundBtn = true
      this.payRefund.refundDesc = this.refundForm.refundDesc
      this.$http({
        url: this.$http.adornUrl(`/pxTrain/trainFefund`),
        method: 'post',
        data: this.payRefund
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success('操作成功！')
          this.refundVisible = false
          this.refundBtn = false
          this.getTrainPerson(1)
          this.getTrainPerson(2)
        }
      })
    },
    //设置替补或主力
    // type: 1参训  2替补
    updateBench (row, type) {
      let title = type == 1 ? '是否设置为参训人员？' : '是否设置为替补人员？'
      if (type === 2) {
        //设为替补，先判断
        if (
          row.payStatus === 2 ||
          row.payStatus === 5 ||
          row.payStatus === 6 ||
          row.payStatus === 8 ||
          row.payStatus === 10
        ) {
          this.$message.error('提示：请先进行退费操作!')
          return
        }
      }
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.$http({
            url: this.$http.adornUrl(`/pxTrainPerson/settingPerson`),
            method: 'post',
            data: {
              id: row.id,
              state: type
            }
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message.success('操作成功!')
              this.getTrainPerson(1)
              this.getTrainPerson(2)
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },
    //删除时校验
    initEnrollDataChange (arr) {
      let idarr = []
      arr.forEach((e) => {
        idarr.push(e.id)
        if (
          e.payStatus === 2 ||
          e.payStatus === 5 ||
          e.payStatus === 6 ||
          e.payStatus === 8 ||
          e.payStatus === 10
        ) {
          this.$message.error('提示：' + e.name + '请先进行退费操作!')
          idarr = []
        }
      })
      return idarr
    },
    //删除人员
    delEnroll (row) {
      let idsarr = []
      if (row) {
        //单个删除
        idsarr = this.initEnrollDataChange([row])
      } else {
        //批量删除
        if (
          this.enrollDataOneChange.length + this.enrollDataTwoChange.length <
          1
        ) {
          return this.$message.error('提示：请勾选要删除的人员！')
        }
        let delArr = this.enrollDataOneChange.concat(this.enrollDataTwoChange)
        idsarr = this.initEnrollDataChange(delArr)
      }
      console.log('要删除的参训人员：', idsarr)
      if (idsarr.length > 0) {
        let id = idsarr.join()
        this.$confirm('是否删除人员', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async () => {
            this.$showLoading()
            this.$http({
              url: this.$http.adornUrl(`/pxTrainPerson/delPerson/${id}`),
              method: 'post'
            }).then((data) => {
              if (data && data.code === 0) {
                this.$message.success('删除成功！')
                this.getTrainPerson(1)
                this.getTrainPerson(2)
                this.$showLoading('close')
              }
            })
          })
          .catch(() => {
            this.$message.info('已取消')
          })
      }
    },

    viewParent(row){
      console.log(row)
      this.viewParentVisible=true
      let data={
          bindMbIds:[row.memberId]
      }
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getParentMembersByTeen`),
        method: 'post',
        data
      }).then((data) => {
        if (data && data.code === 0) {
          console.log('家长列表', data)
          this.parentList=data.data
        }
      }) 
    },
    //查询参训人员列表 状态（1参训人员、2替补人员）
    getTrainPerson (state) {
      this.$http({
        url: this.$http.adornUrl(`/pxTrainPerson/list`),
        method: 'post',
        data: {
          page: 1,
          limit: 99999,
          trainId: this.trainId,
          state: state
        }
      }).then((data) => {
        if (data && data.code === 0) {
          console.log('参训人员', state, data)
          if (state == 1) {
            this.getNowPerson()
            this.enrollDataOne = data.page.records
          } else if (state == 2) {
            this.enrollDataTwo = data.page.records
          }
          this.totalPage = data.page.total
        }
      })
    },
    init (row) {
      // this.isDesabled = row.state == 6
      this.isDesabled = !row.state
      this.isbench = row.bench
      this.handData = row
      this.trainId = row.id || ''
      this.radio = undefined
      this.$forceUpdate()
      this.regMember = ''
      this.initMember = ''
      this.honour = ''
      this.enrollData = []
      this.enrollDataOne = []
      this.enrollDataTwo = []
      this.enrollDataChange = []
      this.enrollDataOneChange = []
      this.enrollDataTwoChange = []
      this.getTrainPerson(1)
      this.getTrainPerson(2)

      this.visible = true
    },
    getNowPerson () {
      this.$http({
        url: this.$http.adornUrl(`/pxTrain/queryByTrainNum/${this.trainId}`),
        method: 'post'
      }).then((res) => {
        console.log(res)
        let train = res.data
        this.nowPerNum = train.joinCount
        if (
          this.handData.state === 4 &&
          this.nowPerNum >= train.classCount &&
          train.bench === 1
        ) {
          this.stateName = '报满可替'
        } else if (
          this.handData.state === 4 &&
          this.nowPerNum >= train.classCount &&
          train.bench === 0
        ) {
          this.stateName = '已报满'
        } else {
          this.stateName = ''
        }
      })
    },
    checkAll (val) {
      this.nowSelectData = val
    },
    checkRightAll (val) {
      this.nowSelectRightData = val
    },
    // 选中
    handelSelect () {
      this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData)
      this.handleRemoveTabList(this.nowSelectData, this.leftData)
      this.nowSelectData = []
    },
    // 取消
    handleRemoveSelect () {
      this.leftData = this.handleConcatArr(
        this.leftData,
        this.nowSelectRightData
      )
      this.handleRemoveTabList(this.nowSelectRightData, this.rightData)
      this.nowSelectRightData = []
    },
    handleConcatArr (rightData, nowSelectData) {
      let arr = []
      arr = arr.concat(rightData, nowSelectData)
      return arr
    },
    handleRemoveTabList (isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]['name'] === originalArr[k]['name']) {
              originalArr.splice(k, 1)
            }
          }
        }
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getLeftData()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getLeftData()
    },
    //主力勾选事件
    enrollOneChange (val) {
      this.enrollDataOneChange = val
    },
    //主力勾选事件
    enrollTwoChange (val) {
      this.enrollDataTwoChange = val
    }
  }
}
</script>
<style>
.width_label {
  width: 180px;
}
.opSetting {
  text-align: center;
  margin-top: 30px;
}
.spacing {
  margin-top: 10px;
}
.font_label {
  font-weight: bold;
  font-size: 18px;
}

.el-radio.is-bordered {
  width: 140px;
  padding: 12px 20px 0 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 40px;
}

/* 分页样式 */
.el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 20.5px;
  height: 28px;
  line-height: 28px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}
</style>
